import { doodBlockConfig } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PUSHROWBLOCK_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  pushRowBlockDescriptor: _generatedPushRowBlockDescriptor,
  pushRowBlockBlocDefinition,
  pushRowBlockDashboardLayout,
  pushRowBlockConfig,
  pushRowBlockResolveConfig,
  pushRowBlockProperties,
} = doodBlockConfig(
  {
    name: "Push row",
    componentType: 'PushRowBlockComponent',
    category: 'content',
    description: "Push row.",
    keywords: [],
    hideFromPicker: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'pushes',
        name: "pages.blocks.push-row.pushes.label",
        accept: 'explicitOnly',
        allowedTypes: ["Push.?Block", "BigPushBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.push-row.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.push-row.fieldset.pushes.label",
            fields: ["pushes"],
          },
        ],
      },
    ],
  })
);

export function pushRowBlockDescriptor(): IBlockDescriptor;
export function pushRowBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function pushRowBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPushRowBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPushRowBlockDescriptor, pushRowBlockProperties, fieldOrder);
}

export {
  pushRowBlockBlocDefinition,
  pushRowBlockDashboardLayout,
  pushRowBlockProperties,
  pushRowBlockConfig,
  pushRowBlockResolveConfig,
};

export type PushRowBlockConfig = typeof pushRowBlockConfig;
